import fetchApi from "../fetchApi";
export const RequestCreateBatchOrder = async (
    {
        corporate_customer_id = '',
        total_cost= '',
        total_tax='',
        office_id = '',
        quantity = '',
        start_processor_reference = '',
        end_processor_reference = '',
        load_amount = '',
        payments = [],
        skip_activation_fee = false
    }) => {
    const payload = {
      total_cost: total_cost,
      total_tax: total_tax,
      office_id: office_id,
      quantity: quantity,
      start_processor_reference: start_processor_reference,
      end_processor_reference: end_processor_reference,
      load_amount: load_amount,
      payments: payments,
      skip_activation_fee: skip_activation_fee,
    };
    if(corporate_customer_id !== '') {
        payload.corporate_customer_id = corporate_customer_id
    }
    const options = {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/json'
        }),
        body: JSON.stringify(payload),
        redirect: 'follow'
    }

    return await fetchApi(`card-issuing/sell-order/batch`, options);
};